import AdminsPage from './AdminsPage'
import { adminsMenu } from './sideBarOption'

export { adminsMenu }
export default AdminsPage
